import { PlatformShortcode } from '@/utils/convert-platform'

export const isPlatformShortcode = (
  shortcode: string,
): shortcode is PlatformShortcode => {
  return Object.values(PlatformShortcode).includes(
    shortcode as PlatformShortcode,
  )
}
